import React from 'react';
import { useSpring, animated } from '@react-spring/web';
import { useInView } from 'react-intersection-observer';
import styled from 'styled-components';
import { creatorOrange } from '../../../constants/colors';

const Container = styled(animated.div)`
  font-family: 'Oswald';
  font-size: 25px;
  font-weight: 500;
  text-transform: uppercase;
  background-color: #202020;
  color: #ffffff;
  padding: 100px;
  border-radius: 50px;
  line-height: 0.95;
  letter-spacing: -0.04em;
  text-align: left;
  margin: 0 auto;
  /* Match navbar width - 80% of screen */

  max-width: 1400px;

  /* Responsive adjustments to match navbar breakpoints */
  @media screen and (max-width: 1200px) {
    width: 80%;
    font-size: 22px;
    padding: 80px;
  }

  @media screen and (max-width: 768px) {
    width: 80%; /* Match mobile navbar width */
    padding: 60px 40px;
    border-radius: 20px;
    font-size: 16px;
    line-height: 1.1;
  }

  @media screen and (max-width: 480px) {
    width: 80%;
    padding: 40px 30px;
    font-size: 14px;
    border-radius: 15px;
  }
`;

const Highlight = styled.span`
  font-weight: 500;
  color: ${creatorOrange};
`;

const MissionStatement = () => {
  const { ref, inView } = useInView({
    triggerOnce: true,
    threshold: 0.1,
  });

  const bounceAnimation = useSpring({
    transform: inView ? 'scale(1)' : 'scale(0.8)',
    opacity: inView ? 1 : 0,
    config: { tension: 170, friction: 12, mass: 1 },
  });

  return (
    <Container ref={ref} style={bounceAnimation}>
      EDC is powering the <Highlight>future of advertising</Highlight> in the{' '}
      <Highlight>algorithmic era</Highlight> by innovating brand-creator
      ecosystems to deliver{' '}
      <Highlight>authentic, relatable content at scale</Highlight>
      .
      <br />
      <br />
      Our approach fuels <Highlight>meaningful consumer connections</Highlight>,
      drives <Highlight>measurable business growth</Highlight>, and creates a{' '}
      <Highlight>positive impact</Highlight> - good for business, good for
      society.
    </Container>
  );
};

export default MissionStatement;
